import { type UserPreferencesRepository } from './types';
import { resolveWebKeyValueStore, type WebKeyValueStore } from './webKeyValueStore';

const STORAGE_KEY_PREFIX = 'digima.user_preferences';

const buildStorageKey = (userId: string, key: string) => `${STORAGE_KEY_PREFIX}.${userId}.${key}`;

const createWebUserPreferencesRepository = (
  store: WebKeyValueStore,
): UserPreferencesRepository => ({
  getValue: async (userId, key) => store.getItem(buildStorageKey(userId, key)),
  setValue: async (userId, key, value) => {
    store.setItem(buildStorageKey(userId, key), value);
  },
});

const userPreferencesRepository = createWebUserPreferencesRepository(resolveWebKeyValueStore());

export { createWebUserPreferencesRepository, userPreferencesRepository };
